import React, { useState } from "react";
import "@styles/SingleHotelViewcss/OrderTable.css";
import { useStaff } from "@hooks/users/foodcourtStaff/useStaff";
import { Staff } from "types/users/userTypes";
import arrow from '@images/back.png';

const AdminStaffTable: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 7;

  // Fetch staff data (full list of staff)
  const { data, isLoading, error } = useStaff();
  console.log("staff", data);

  if (!data) return <p>No data available.</p>;

  const totalPages = 1;  // Total pages from the API response
  const currentRecords = data;  // Current records from API response

  // Pagination controls
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  return (
    <>
      <div className="transaction-table-container">
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Username</th>
                <th>Name</th>
                <th>Email</th>
                <th>Role/Business Name</th>
                <th>Last Login</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords && currentRecords.length > 0 ? (
                currentRecords?.map((Customer: Staff) => (
                  <tr key={Customer.userId || Customer.email}> {/* Use email or fallback */}
                    <td>{Customer.username || "N/A"}</td> {/* Fallback if null */}
                    <td>{Customer.fullName || "No Name Available"}</td> {/* Fallback if null */}
                    <td>{Customer.email}</td>
                    <td>{Customer.role}</td>
                    <td>{Customer.lastLogin ? new Date(Customer.lastLogin).toLocaleString() : "Never"}</td> {/* Handle null dates */}
                    <td>
                      <button
                        className="view-details-button"
                        style={{ padding: "17px 5px" }}
                      >
                        <span>View Details</span>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} style={{ padding: "12px" }}>No records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination Controls */}
      <div className="pagination-controls">
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            className="pagination-button"
          >
            <img src={arrow} alt="<" />
          </button>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="pagination-button"
          >
            <img src={arrow} alt=">" style={{ transform: 'rotate(180deg)' }} />
          </button>
        </div>
      </div>
    </>
  );
};

export default AdminStaffTable;
